'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useReducer } from 'react';
import { createLeadMagnetReducer, LEAD_MAGNET_INITIAL_STATE } from '@/lib/lead-magnet/reducer';
import { readSnapshot, writeSnapshot } from '@/lib/lead-magnet/storage';
import { LeadMagnetIdentity, QuizQuestion } from '@/types/lead-magnet';
const useLeadMagnetState = (questions, identity) => {
  const $ = _c(13);
  let t0;
  if ($[0] !== questions) {
    t0 = createLeadMagnetReducer(questions);
    $[0] = questions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const reducer = t0;
  const [state, dispatch] = useReducer(reducer, LEAD_MAGNET_INITIAL_STATE);
  const {
    storageKey,
    structureHash
  } = identity;
  let t1;
  let t2;
  if ($[2] !== storageKey || $[3] !== structureHash) {
    t1 = () => {
      dispatch({
        type: "HYDRATE",
        snapshot: readSnapshot({
          storageKey,
          structureHash
        })
      });
    };
    t2 = [storageKey, structureHash];
    $[2] = storageKey;
    $[3] = structureHash;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[6] !== state || $[7] !== storageKey || $[8] !== structureHash) {
    t3 = () => {
      if (!state.hydrated) {
        return;
      }
      writeSnapshot(state, {
        storageKey,
        structureHash
      });
    };
    t4 = [state, storageKey, structureHash];
    $[6] = state;
    $[7] = storageKey;
    $[8] = structureHash;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== state) {
    t5 = [state, dispatch];
    $[11] = state;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5 as const;
};
export default useLeadMagnetState;